<template>
  <b-list-group class="tt-border-radius">
    <b-list-group-item
      class="d-flex justify-content-between align-items-center bg-primary text-white tt-border-radius"
    >
      Cars
    </b-list-group-item>
    <template v-if="carList.length > 0">
      <b-list-group-item
        v-for="car in carList"
        :key="car._id"
        class="text-left tt-border-radius"
        :class="{ 'bg-light-gray': car.is_default_car }"
      >
        <div class="row">
          <div class="col-1">
            <span>
              <b-icon
                icon="exclamation-circle-fill"
                variant="warning"
                v-if="!car.is_synced"
              ></b-icon>
            </span>
          </div>
          <div class="text-left col-10">
            <small>{{ car.registration_number }}</small
            ><br />
            {{ car.make }} - {{ car.model }}
          </div>
          <div class="col-1">
            <b-icon
              v-if="isloggedIn"
              icon="pencil-square"
              :disabled="true"
              scale="1"
              @click="editCar(car)"
            ></b-icon>
            <!--          <b-icon icon="x-circle"-->
            <!--                  scale="1"-->
            <!--                  variant="danger"-->
            <!--                  v-b-modal.modal-center-->
            <!--                  modal-ok.delete-->
            <!--                  @click="selectedTrip=car._id">-->
            <!--          </b-icon>-->
          </div>
        </div>
      </b-list-group-item>
    </template>
  </b-list-group>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "Car",
  created() {
    this.$store.dispatch("car/getAllCarsAction");
  },
  computed: {
    ...mapState({
      vehicles: state => state.car.userSavedVehicles,
      isloggedIn: state => state.auth.isAuth
    }),
    ...mapGetters({
      defaultVehicle: "car/getDefaultCar",
      defaultVehicleList: "car/getDefaultCarsList",
      getUsersSavedCarsList: "car/getUsersSavedCarsList"
    }),
    carList: function() {
      return [this.defaultVehicle, ...this.getUsersSavedCarsList];
    }
  },
  methods: {
    editCar: function(car) {
      this.$emit("editableCar", car);
    }
  }
};
</script>

<style scoped></style>
